import React from 'react';
import clsx from 'clsx';

interface LoadingIndicatorProps {
  className?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ className }) => {
  return (
    <span
      className={clsx(
        'inline-block h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-proposio-purple',
        className
      )}
      aria-hidden="true"
    />
  );
};

export default LoadingIndicator;
